var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8107 7.64017L21.1834 0.858838C19.2199 -0.286318 16.7802 -0.28624 14.8166 0.858838L3.1894 7.64017C1.22207 8.78743 0 10.927 0 13.2239V26.776C0 29.0729 1.22207 31.2125 3.18932 32.3598L14.8166 39.1411C16.7805 40.2865 19.2201 40.2861 21.1834 39.1411L32.8106 32.3598C34.7779 31.2125 36 29.0729 36 26.776V13.2239C36 10.9271 34.7779 8.78751 32.8107 7.64017ZM32.9099 26.776C32.9099 27.9592 32.2804 29.0613 31.267 29.6522L19.6397 36.4335C18.6282 37.0235 17.3717 37.0235 16.3602 36.4335L4.73292 29.6522C3.71959 29.0612 3.09013 27.9592 3.09013 26.776V13.2239C3.09013 12.0409 3.71959 10.9388 4.733 10.3478L16.3602 3.56649C17.3718 2.97649 18.6287 2.97673 19.6398 3.56649L31.2671 10.3477C32.2804 10.9388 32.9099 12.0408 32.9099 13.2239V26.776Z",
    fill: "#445964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.5d30d5567405db7e23097883887658cb.svg";
export { ForwardRef as ReactComponent };